var _jsxFileName = "/codebuild/output/src2209540979/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/auth/ResetPassword/states/ResetFailure.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
import { ThemedImage } from 'Components/utility';
import i18n from 'Utilities/i18n';
const ResetFailure = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThemedImage, {
    resourceKey: "ResetPasswordFailure.content.resetPasswordFailureContent.media.pwResetLockLight",
    alt: "password reset failure illustration",
    id: "ResetPasswordFailure.content.resetPasswordFailureContent.media.pwResetLock",
    style: {
      marginTop: '40px',
      height: '105px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordFailure.content.resetPasswordFailureContent.primaryText",
    testID: "ResetPasswordFailure.content.resetPasswordFailureContent.primaryText",
    fontWeight: '$h2.medium',
    fontSize: "$h2.medium",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, i18n.t('ResetPasswordFailure.content.resetPasswordFailureContent.primaryText')), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText",
    testID: "ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText",
    color: "$text.100",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, i18n.t('ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText')));
};
export { ResetFailure };